// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var InvoiceDraftController = function ($scope, $location, $http, InvoiceDraft, BillingSettings, SharedParameters, DunningsCount, Features) {

    $scope.checkInvoiceDraftFeature = function () {
        return Features.loadingAsPromise().then(
            function (response) {
                const features = response.data;
                if (!features.includes('InvoiceDrafts')) {
                    $location.path("/documents/invoices-credit-notes-final");
                }
            },
            function (error) {
                console.log(error)
            }
        );
    }
 
    $scope.checkInvoiceDraftFeature();
    $scope.billingSettings = BillingSettings.get();
    $scope.updateFilter = function () {
        SharedParameters.setValue('invoiceDraftFilter', $scope.filter);
        $scope.documents = $scope.paginator(InvoiceDraft.query, { search: $scope.filter }, 20);
    };
    $scope.filter = SharedParameters.getValue('invoiceDraftFilter');
    if (!$scope.filter)
        $scope.filter = "";
    $scope.updateFilter();
    updatedDunningsCount();

    $scope.sendInvoice = function (document) {
        if (document.sendClicked)
            return;
        document.sendClicked = true;
        var draftId = document.Id;
        $http({
            method: "POST", url: "/api/v1/InvoiceDrafts/" + draftId, params: null,
            data: {}, headers: {}, cache: false
        }).then(function () {
            $scope.updateFilter();
        }, function () {
            document.sendClicked = false;
        });
    };

    $scope.dunningsCount = 0;
    function updatedDunningsCount() {
        DunningsCount.get({ drafts: true }, function (data) {
            $scope.dunningsCount = (data && data.Count) ? data.Count : 0;
        });
    }
};
InvoiceDraftController.$inject = ['$scope', '$location', '$http', 'InvoiceDraft', 'BillingSettings', 'SharedParameters', 'DunningsCount', 'Features'];
